import React from "react";
import {Form} from "react-bulma-components";


export default function TaxTypePicker({onChange, label, name, value, disabled, className}){



    const options = {results: [
        {id:-1, name:"", value:""},
        {id:1, name: "20% (VAT on Expense)" , value: "INPUT2"},
        {id:2, name: "20% (VAT on Income)", value: "OUTPUT2"},
        {id:3, name: "5% (VAT on Expense)", value: "RRINPUT"},
        {id:4, name: "5% (VAT on Income)", value: "RROUTPUT"},
        {id:5, name: "EC Acquisitions (20%)", value: "ECACQUISITIONS"},
        {id:6, name: "EC Acquisitions (Zero Rated)", value: "ECZRACQUISITIONS"},
        {id:7, name: "Exempt Expenses", value: "EXEMPTINPUT"},
        {id:8, name: "Exempt Income", value: "EXEMPTOUTPUT"},
        {id:9, name: "No VAT", value: "NONE"},
        {id:10, name: "Reverse Charge Expenses (20%)", value: "REVERSECHARGES"},
        {id:11, name: "VAT on imports", value: "GSTONIMPORTS"},
        {id:12, name: "Zero Rated EC Goods Income", value: "ECZROUTPUT"},
        {id:13, name: "Zero Rated EC Services", value: "ECZROUTPUTSERVICES"},
        {id:14, name: "Zero Rated EC Expenses", value: "ECZRINPUT"},
        {id:15, name: "Zero Rated Income", value: "ZERORATEDOUTPUT"},
        {id:16, name: "Zero Rated Expenses", value: "ZERORATEDINPUT"}
    ]}

    const getValue = () => {
        let index = options.results.findIndex(ele => ele.value === value);
        if(index !== -1) {
            return options.results[index]['value'];
        }
        else{
            return options.results[0]['value']
        }
    }

    return (
        <Form.Field>
            {label && <Form.Label>{label}</Form.Label>}
            <Form.Control>
                <Form.Select
                    name={name}
                    value={getValue()}
                    onChange={onChange}
                    disabled={disabled}
                    className={className || ""}
                >
                    {options.results.map(option => (
                        <option key={option.id} value={option.value}>{option['name']}</option>
                    ))}
                </Form.Select>
            </Form.Control>
        </Form.Field>
    )



}